import { bffInstance } from "../api/axiosInstance";
import { useMutation, useQueryClient } from 'react-query';

const updateDefaultWorkflow = async (workflowId: string, isDefault: boolean) => {
  const res = await bffInstance.patch('/updateDefaultWorkflow', {
    workflowId,
    isDefault,
  });
  return res.data;
};

export const useUpdateDefaultWorkflow = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, isDefault }: { id: string; isDefault: boolean }) =>
      updateDefaultWorkflow(id, isDefault),
    {
      onSuccess: () => {
         queryClient.invalidateQueries(['unifyProfile']);
      },
    }
  );
};